module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Group-b56906313f929c66871c31b025308ccb.svg";